import Cities from "./cities.json";
import { iCity } from "./interfaces/cities";

const cities: iCity[] = Cities;

export default cities;

